export interface CreateReservationPaylaod {
  source_amount?: string;
  source_currency?: string;
  dest_currency?: string;
  dest?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  email?: string;
  country?: string;
  state?: string;
  city?: string;
  postal_code?: string;
  street?: string;
  payment_type?: string;
  redirect_url?: string;
  failure_redirect_url?: string;
}

export enum WyreOrderStatus {
  COMPLETE = "COMPLETE",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  RUNNING_CHECKS = "RUNNING_CHECKS"
}

export interface WyreOrder {
  account_id: string;
  created_at: number;
  dest: string;
  dest_amount: string;
  dest_asset: {
    asset_id: string;
    icon: string;
    name: string;
    symbol: string;
  };
  dest_currency: string;
  dest_fee: string;
  exchange_rate: string;
  id: string;
  order_type: string;
  owner: string;
  payment_method_name: string;
  reference_id: string;
  source_amount: string;
  source_amount_without_fees: string;
  source_currency: string;
  source_fee: string;
  status: WyreOrderStatus;
  transfer_id: string;
  user_id: string;
  wallet_type: string;
  wyre_order_id: string;
}
